import Swiper from 'swiper';

const frontpageNewsSlider = {
	init: function() {
		
		const under = document.querySelector(".under");
		if( window.innerWidth < 992 && under ) {

			// move the most recent post from above as first child
			under.insertBefore(document.querySelector(".above .tilePrimary "), document.querySelector(".under .tilePrimary "))

			// wrap child inside swiper-wrapper div
			under.innerHTML = "<div class='swiper-wrapper'>" + under.innerHTML + "</div>"
			
			// init swiper
			window.frontpageNewsSlider = new Swiper(
				under,
				{
					slidesPerView: 'auto',
					spaceBetween: 32,
				}
			);
		}
	},

};

export default frontpageNewsSlider;